'use strict';

import angular from 'angular';

/**
 * Service de stockage pour gérer le localStorage
 */
export default angular.module('observatoireApp')
  .factory('StorageService', function() {
  
  return {
    get: get,
    set: set,
    remove: remove
  };
  
  /**
   * Récupère une valeur du localStorage
   * @param {string} key - Clé à récupérer
   * @returns {string} - Valeur stockée
   */
  function get(key) {
    return localStorage.getItem(key);
  }
  
  /**
   * Définit une valeur dans le localStorage
   * @param {string} key - Clé à définir
   * @param {string} value - Valeur à stocker
   */
  function set(key, value) {
    localStorage.setItem(key, value);
  }
  
  /**
   * Supprime une valeur du localStorage
   * @param {string} key - Clé à supprimer
   */
  function remove(key) {
    localStorage.removeItem(key);
  }
});
